module.exports = __webpack_public_path__ + "img/2_en.1626b81.png";